import React, { useEffect, useState } from "react";
import doller_landing from "./../../../../assets/doller_landing.png";
import "./MyordersPage.css";
import { connect } from "react-redux";
import OrderDatails from "./Orderdetail";
import NodatafoundPage from "../../../nodatafound/components/NodatafoundPage";
import no_orders from "./../../../../assets/no_orders.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { newOrdercount } from "../../dashboard/redux/actions";
import { fetchHeaderContent } from "../../../seoroute/redux/actions";
import { LazyLoadImage } from "react-lazy-load-image-component";
import location_blue_icon from "../../../../assets/location_blue_icon.svg"
import { getRequestcall } from "../../../comman/util/getRequest";
import { MYORDER_LIST } from "../../../constants/apiurl";
import PaginationPage from "../../../comman/components/PaginationPage";
import moment from "moment";


function OrderlistPage(props) {
  const { access_token } = props;
  const [orderList, setOrderList] = useState({});
  const [nodata, setNodata] = useState();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const orderStatus = [
    {
      orderstatus: "Accepted",
      orderstatus_tr: "Kabul edilmiş",
    },
    {
      orderstatus: "Packed",
      orderstatus_tr: "Paketlenmiş",
    },
    {
      orderstatus: "Dispatched",
      orderstatus_tr: "Sevk edilen",
    },
    {
      orderstatus: "Delivered",
      orderstatus_tr: "Teslim edilmiş",
    },
    {
      orderstatus: "Cancelled",
      orderstatus_tr: "İptal edildi",
    },
  ];

  useEffect(() => {
    callOrderList("1");
    // eslint-disable-next-line
  }, [!orderList, props?.language]);

  const callOrderList = async (page) => {
    props?.fetchHeaderContent(t("pages.sidenav.myorders"), "", "");
    let apiurl = MYORDER_LIST + `?page=${page}`;
    const responceOrder = await getRequestcall(apiurl, access_token);
    if (responceOrder?.status === 200) {
      const resultOrder = await responceOrder.json();
      if (resultOrder?.data?.data.length === 0) {
        setNodata(true);
        setOrderList({ data: [], links: [] });
        props.newOrdercount(0);
      } else {
        setOrderList(resultOrder?.data);
        props.newOrdercount(resultOrder?.data?.data?.my_orders_count);
        setNodata(false);
      }
    }
  };

  const onChangeNotificationPagination = async (pages) => {
    await callOrderList(pages);
  };

  const invoiceDownload = (e, order_id) => {
    e.stopPropagation();
    e.preventDefault();
    window.open(
      `${
        process.env.REACT_APP_BASE_URL
      }/orderInvoice/${order_id}/${props.language.toLowerCase()}`,
      "_blank"
    );
  };

  const navigateToorderdetail = (e, item) => {
    e.preventDefault();
    navigate(`/user/myorders/${item?.id}`);
  };

  if (nodata)
    return (
      <NodatafoundPage
        className={"user-reviews-centent"}
        image={no_orders}
        title={t("pages.myorders.noorder")}
        description={t("pages.myorders.noorder_description")}
        navigation={"/user/dashboard"}
        button={t("pages.myorders.backtodashboard")}
      />
    );

  return (
    <>
      <div className=" user-orderlist card">
        <div className=" card-body order_body">
          <div className="user-orderlist-centent">
            <div className="d-flex align-center justify-content-between align-items-start">
              <h5 className="header-title">{t("pages.myorders.title")}</h5>
            </div>
             <section className="mob-my-orders">
             {orderList?.data?.map((item, index) => (
                <div className="myorders"   onClick={(e) => navigateToorderdetail(e, item)}>
                   <div className="d-flex justify-content-between align-items-baseline">
                    <label>{t("pages.myorders.orderplace")}</label>
                    <h5>
                      {moment(item?.created_at).format("DD-MM-YYYY hh:mm A")}
                    </h5>
                  </div>
                  <div className="d-flex justify-content-between align-items-baseline">
                  <label>{t("pages.myorders.total")}</label>
                  <h5>{Number(item.order_total).toFixed(2)}
                              {process.env.REACT_APP_CURRENCY_SYMBOL}</h5>
                  </div>
                   <div className="d-flex justify-content-between align-items-baseline">
                   <label>{t("pages.myorders.delivery_address")}</label>
                   <p className="text-end">
                     {item?.address}
                   </p>
                    </div>
                   <div className="d-flex justify-content-between align-items-baseline">
                   <label>{t("pages.myorders.order")}</label>
                   <h5>
                   {item?.display_order_id}
                   </h5>
                  </div>
                  <OrderDatails
                    setOrderList={setOrderList}
                    orderList={orderList}
                    {...props}
                    item={item}
                    index={index}
                  />
                <div className="location-detail">
               <div className="d-flex align-items-center">
               <img
                 src={location_blue_icon}
                alt="check"
                height="17"
                width="17"
                 ></img>
                <label
                 className={`blue-color w500 me-2 ms-1`}
                 >
                 {" "}
                {t("pages.myorders.trackorder")}{" "}
               </label>
               </div>
               <div className="d-flex align-items-baseline">
               <label className="secoundary-text">
                            {orderStatus.map((value, index) =>
                              value.orderstatus === item?.order_status ? (
                                props.language === "Tr" ? (
                                  value.orderstatus_tr
                                ) : (
                                  item?.order_status
                                )
                              ) : (
                                <></>
                              )
                            )}
                            :
                          </label>
                          <span className="w500">
                            {" "}
                            {moment(item?.created_at).format("DD-MM-YYYY hh:mm A")}
                          </span>
               </div>
               </div>        
                <div className="invoice-download" onClick={(e) => invoiceDownload(e, item?.id)}>
                <LazyLoadImage
                        alt=""
                        src={doller_landing}
                        className={"invoice_image"}
                      ></LazyLoadImage>
                <label className="pr-color">
                  {t("pages.myorders.invoice_down")}
                </label>
                </div>

              </div>
             ))}
             </section>

            {orderList?.data?.map((item, index) => (
              <div
                key={index.toString()}
                className="order_card mb-3 card"
                onClick={(e) => navigateToorderdetail(e, item)}
              >
                <div className="card-body  order_card_body">
                  <div className="card_table">
                    <div className="card_body">
                      <table id={"orderdatil"}>
                        <thead>
                          <tr className="detail secoundary-text">
                            <th>{t("pages.myorders.orderplace")}</th>
                            <th>{t("pages.myorders.total")}</th>
                            <th>{t("pages.myorders.delivery_address")}</th>
                            <th className="right">
                              {t("pages.myorders.order")}{" "}
                              {item?.display_order_id}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="detail_title">
                            <td>
                            {moment(item?.created_at).format("DD-MM-YYYY hh:mm A")}
                            </td>
                            <td className="align-baseline">
                              {Number(item.order_total).toFixed(2)}
                              {process.env.REACT_APP_CURRENCY_SYMBOL}
                            </td>
                            <td>{item?.address}</td>
                            <td align="right">
                              {t("pages.myorders.orderdetails")}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <OrderDatails
                    setOrderList={setOrderList}
                    orderList={orderList}
                    {...props}
                    item={item}
                    index={index}
                  />
                  <div className="invoice">
                    {item?.order_status === "Delivered" ? (
                      <h5 className="text-14 green-color">
                        {t("pages.myorders.deliveredon")}{" "}
                        {moment(item?.created_at).format("DD-MM-YYYY hh:mm A")}
                      </h5>
                    ) : (
                      <div className="track_order">
                        <img
                          src={location_blue_icon}
                          className={item?.order_status}
                          alt="order status"
                          height="20"
                          width="20"
                        ></img>
                        <label
                          className={`blue-color me-2 color-${item?.order_status}`}
                        >
                          {" "}
                          {t("pages.myorders.trackorder")}{" "}
                        </label>
                        <h5 className="text-14 mb-0">
                          <label className="secoundary-text">
                            |
                            {orderStatus.map((value, index) =>
                              value.orderstatus === item?.order_status ? (
                                props.language === "Tr" ? (
                                  value.orderstatus_tr
                                ) : (
                                  item?.order_status
                                )
                              ) : (
                                <></>
                              )
                            )}
                            :
                          </label>
                          <span className="w500">
                            {" "}
                            {moment(item?.created_at).format("DD-MM-YYYY hh:mm A")}
                          </span>
                        </h5>
                      </div>
                    )}
                    <div
                      className="invoice_detail"
                      onClick={(e) => invoiceDownload(e, item?.id)}
                    >
                      <label className="pr-color">
                        {t("pages.myorders.invoice_down")}
                      </label>
                      <LazyLoadImage
                        alt=""
                        src={doller_landing}
                        className={"invoice_image"}
                      ></LazyLoadImage>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="col-12 text-end mt-5">
            {!nodata && orderList?.total > 10 && (
              <PaginationPage
                changeCurrentpage={onChangeNotificationPagination}
                nopagination={nodata}
                links={orderList?.links}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
const mapStateToProps = (state) => ({
  access_token: state?.login.access_token,
  language: state?.languageState?.language,
});
export default connect(mapStateToProps, { newOrdercount, fetchHeaderContent })(
  OrderlistPage
);
